export const AEON_TOOLBAR = "AEON_TOOLBAR";

export const TIMELINE_VIEW = "TIMELINE_VIEW";
export const RELATIONSHIP_VIEW = "RELATIONSHIP_VIEW";
export const RELATIONSHIP_VIEW_ROW = "RELATIONSHIP_VIEW_ROW";
export const RELATIONSHIP_VIEW_COLUMN = "RELATIONSHIP_VIEW_COLUMN";
export const RELATIONSHIP_VIEW_HEADER_GROUP = "RELATIONSHIP_VIEW_HEADER_GROUP";
export const NARRATIVE_VIEW = "NARRATIVE_VIEW";
export const MINDMAP_VIEW = "MINDMAP_VIEW";
export const SPREADSHEET_VIEW = "SPREADSHEET_VIEW";
export const OUTLINE_VIEW = "OUTLINE_VIEW";
export const SUBWAY_VIEW = "SUBWAY_VIEW";
export const ENTITY_LIST_VIEW = "ENTITY_LIST_VIEW";
export const MODAL_MASTER_LIST_VIEW = "MODAL_MASTER_LIST_VIEW";
export const SETTINGS_OPTION_LIST_VIEW = "SETTINGS_OPTION_LIST_VIEW";
export const NARRATIVE_LABEL_LIST_VIEW = "NARRATIVE_LABEL_LIST_VIEW";
export const SEARCH_RESULTS_VIEW = "SEARCH_RESULTS_VIEW";
export const TABLE_VIEW_HEADER = "TABLE_VIEW_HEADER";
export const TABLE_VIEW = "TABLE_VIEW";
export const TREE_VIEW = "TREE_VIEW";
export const ITEM_CARD_LIST_VIEW = "ITEM_CARD_LIST_VIEW";
export const ITEM_CARD_SEQUENCE_LIST_VIEW = "ITEM_CARD_SEQUENCE_LIST_VIEW";
export const ITEM_CARD_NARRATIVE_LIST_VIEW = "ITEM_CARD_NARRATIVE_LIST_VIEW";
export const LAYOUT_VIEW = "LAYOUT_VIEW";
export const MIXED_VIEWS = "MIXED_VIEWS";

export const DIRECTION_LEFT = "DIRECTION_LEFT";
export const DIRECTION_RIGHT = "DIRECTION_RIGHT";
export const DIRECTION_TOP = "DIRECTION_TOP";
export const DIRECTION_BOTTOM = "DIRECTION_BOTTOM";

export const ORIENTATION_ROW = "ORIENTATION_ROW";
export const ORIENTATION_COLUMN = "ORIENTATION_COLUMN";

export const ENTITY_LIST_PANEL = "ENTITY_LIST_PANEL";
export const MARKER_LIST_PANEL = "MARKER_LIST_PANEL";
export const SEARCH_PANEL = "SEARCH_PANEL";
export const GLOBAL_FILTER_PANEL = "GLOBAL_FILTER_PANEL";
export const LOCAL_FILTER_PANEL = "LOCAL_FILTER_PANEL";
export const SYNC_BINDER_PANEL = "SYNC_BINDER_PANEL";

export const ITEM_INSPECTOR_PANEL = "ITEM_INSPECTOR_PANEL";
export const MARKER_INSPECTOR_PANEL = "MARKER_INSPECTOR_PANEL";
export const SYNC_INSPECTOR_PANEL = "SYNC_INSPECTOR_PANEL";
export const TUTORIAL_PANEL = "TUTORIAL_PANEL";
export const COLLAPSED_INSPECTOR_PANEL = "COLLAPSED_INSPECTOR_PANEL";
export const SETTINGS_PANEL = "SETTINGS_PANEL";
export const HARVARD_SETTINGS_PANEL = "HARVARD_SETTINGS_PANEL";
export const CONSTRAINT_PANEL = "CONSTRAINT_PANEL";
export const SCROLL_TO_DATE_PANEL = "SCROLL_TO_DATE_PANEL";

export const GLOBAL_FILTER_ID = "GLOBAL_FILTER_ID";
export const TIMELINE_DROP_TEMPORARY_FILTER_ID = "TIMELINE_DROP_TEMPORARY_FILTER_ID";

export const MENU_POPOVER_DATE = "MENU_POPOVER_DATE";
export const MENU_POPOVER_DURATION = "MENU_POPOVER_DURATION";
export const MENU_POPOVER_SAVE_TEMPLATE_NAME = "MENU_POPOVER_SAVE_TEMPLATE_NAME";

export const TABLET_VIEW_SINGLE = "TABLET_VIEW_SINGLE";
export const TABLET_VIEW_VERTICAL_SPLIT_HALF = "TABLET_VIEW_VERTICAL_SPLIT_HALF";
export const TABLET_VIEW_VERTICAL_SPLIT_ONE_TWO_THIRD = "TABLET_VIEW_VERTICAL_SPLIT_ONE_TWO_THIRD";
export const TABLET_VIEW_HORIZONTAL_SPLIT_HALF = "TABLET_VIEW_HORIZONTAL_SPLIT_HALF";

export const views = {
  TIMELINE_VIEW,
  RELATIONSHIP_VIEW,
  NARRATIVE_VIEW,
  MINDMAP_VIEW,
  SPREADSHEET_VIEW,
  OUTLINE_VIEW,
  SUBWAY_VIEW
};
